import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, readStoredAuthToken } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const hasToken = !!readStoredAuthToken();
  if (!hasToken) auth.logout();
  return hasToken ? true : router.createUrlTree(['/login']);
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isLoggedIn() ? router.createUrlTree(['/inbox']) : true;
};
